/**
 * 获取URL参数值
 * @param {string} name 参数名
 * @returns {string|null} 参数值
 */
export const getUrlParameter = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

/**
 * 构建URL with参数
 * @param {string} baseUrl 基础URL
 * @param {object} params 参数对象
 * @returns {string} 完整URL
 */
export const buildUrlWithParams = (baseUrl, params) => {
  const url = new URL(baseUrl, window.location.origin);
  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined) {
      url.searchParams.append(key, params[key]);
    }
  });
  return url.toString();
};

/**
 * 解析当前路径
 * @returns {object} 路径信息
 */
export const parseCurrentPath = () => {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;
  
  return {
    pathname,
    search,
    hash,
    fullPath: pathname + search + hash
  };
};
